import React from "react";
import { Link } from "react-router-dom";

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("id-ID", { dateStyle: "medium" }).format(date);
}

export default function BlogSidebar({
  categories = [],
  recentPosts = [],
  activeCategory = "all",
  onSelectCategory,
}) {
  return (
    <aside className="space-y-6">
      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900">Kategori</h3>
        <div className="mt-4 space-y-2">
          <button
            type="button"
            onClick={() => onSelectCategory?.("all")}
            className={`flex w-full items-center justify-between rounded-xl px-3 py-2 text-left text-sm transition ${
              activeCategory === "all"
                ? "bg-orange-50 text-orange-700"
                : "hover:bg-gray-50 text-gray-700"
            }`}
          >
            <span>Semua artikel</span>
          </button>

          {categories.map((category) => (
            <button
              key={category.slug}
              type="button"
              onClick={() => onSelectCategory?.(category.slug)}
              className={`flex w-full items-center justify-between rounded-xl px-3 py-2 text-left text-sm transition ${
                activeCategory === category.slug
                  ? "bg-orange-50 text-orange-700"
                  : "hover:bg-gray-50 text-gray-700"
              }`}
            >
              <span>{category.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900">Artikel Terbaru</h3>
        <div className="mt-4 space-y-4">
          {recentPosts.map((post) => (
            <Link
              key={post.id || post.slug}
              to={`/blog/${post.slug}`}
              className="block rounded-xl border border-gray-100 p-3 transition hover:border-orange-200 hover:bg-orange-50"
            >
              <p className="line-clamp-2 text-sm font-semibold text-gray-900">
                {post.title}
              </p>
              <p className="mt-1 text-xs text-gray-500">
                {formatDate(post.published_at)}
              </p>
            </Link>
          ))}
          {!recentPosts.length ? (
            <p className="text-sm text-gray-500">Belum ada artikel terbaru.</p>
          ) : null}
        </div>
      </div>
    </aside>
  );
}
